import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-translating-page',
  templateUrl: './translating-page.component.html',
  styleUrls: ['./translating-page.component.scss']
})
export class TranslatingPageComponent implements OnInit {

  constructor(public _ui: UtilsService) { }

  ngOnInit() {
  }

}
